import { CurrenciesResponse } from "@cede/types";
import { getCurrencySymbol } from "../amount/formatter";
import { fetchAvailableCurrencies } from "../api-client";

export const getAvailableCurrencies = async () => {
  const data = await fetchAvailableCurrencies().catch(
    () => ({ data: { currencies: { fiat: [], crypto: [] }, updatedAt: "0" } }) as CurrenciesResponse,
  );
  return (data.data?.currencies.fiat || []).filter((currency) => {
    try {
      // Check that the currency is supported by the browser
      getCurrencySymbol("en-US", currency);
      return true;
    } catch {
      return false;
    }
  });
};

export const SMALLEST_SHOWN_FIAT_AMOUNT = 0.01;
export * from "./existingFiatCurrencies";
export * from "./formatFiatCurrency";
